import http from './http'

export function login(data) {
  return http.post('/users/login/', data)
}

export function refresh(data) {
  return http.post('/users/refresh/', data)
}

export function getMe() {
  return http.get('/users/me/')
}

export function updateMe(data) {
  return http.patch('/users/me/', data)
}

export function changePassword(data) {
  return http.post('/users/change-password/', data)
}

export function getUsers(params) {
  return http.get('/users/', { params })
}
